import { useCallback, useMemo, useState } from 'react';
import { BreadcrumbsContext } from './breadcrumbsContext';
import type { BreadcrumbItem } from './breadcrumbsTypes';
import type { PropsWithChildren } from 'react';

type BreadcrumbsProviderProps = PropsWithChildren<{
  items: BreadcrumbItem[];
  visible?: boolean;
}>;

export const BreadcrumbsProvider = ({
  items,
  visible = true,
  children,
}: BreadcrumbsProviderProps): JSX.Element => {
  const [overrideItems, setOverrideItems] = useState<BreadcrumbItem[] | null>(null);
  const [overrideVisible, setOverrideVisible] = useState<boolean | null>(null);
  const resolvedItems = overrideItems ?? items;
  const resolvedVisible = overrideVisible ?? visible;
  const clearOverride = useCallback(() => {
    setOverrideItems(null);
    setOverrideVisible(null);
  }, []);
  const contextValue = useMemo(
    () => ({
      items: resolvedItems,
      visible: resolvedVisible,
      setOverrideItems,
      setOverrideVisible,
      clearOverride,
    }),
    [clearOverride, resolvedItems, resolvedVisible],
  );

  return <BreadcrumbsContext.Provider value={contextValue}>{children}</BreadcrumbsContext.Provider>;
};
